// @ts-nocheck
/* eslint-disable */

exports.colors = void 0;
var colors = {
  white: '#ffffff',
  black: '#000000',
  primaryBrand1: '#0c1e2c',
  primaryBrand2: '#275b86',
  primaryBrand3: '#3f88c5',
  primaryBrand4: '#4ba1e9',
  secondaryBrand1: '#d7d6cb',
  secondaryBrand2: '#e2ded1',
  secondaryBrand3: '#f1efe9',
  primaryFont: '#0c1e2c',
  accentFont: '#4ba1e9',
  error: '#ff4949',
  // warning colors: orange and yellow
  warning1: '#ff8500',
  warning2: '#ffdd00',
  // darkest/worse (1) to lightest/best (3)
  success1: '#7ac121',
  success2: '#7ad521',
  success3: '#7aeb21'
};
exports.colors = colors;
